
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gPSOYo_451OlpxbStgPfEnxDX3tm4H1H3FcI3uWZmK_45yToMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index5TqwC3d8nWBz1XjTrsYtJu_mYvJaYJd46nLbYQbj_fMMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchqdFXDZkrXvlQNmhZq1h8Ew82yqNaS_458PS9x58VbVI2gMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexnW3ZrJuHvtSfUC4KoGtUvkFh1O7QeMfK1AQ2hagy3JcMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_932GGOMzapSVW0WGAMxGg0gIl5R7zxdJPtD8Y9kUXufawMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexBOKtt9yhPtjzM00KkD2B__45eJkGGKcFmk41wVkM6_5_45YMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93XZ8Q5CYUejnU8_JGTAbU4yAhVHdfqxjhd_45WIctu6gnMMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexElzlrUfl7Xe_45vz3SmScBZ1sWxcZI4vrTteIUPnIljrIMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93DkGXupVcs_VpsdHsqEGgWUDPknRxPAcA3lfTO_45VG3_sMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indextAXpiDrfEEEtzGBCqDr8JpNF2YTayZxkK0e0vKhOT5wMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexs_451Ft4y0bb0rtX8idji3TovwKOKjShNipTzeQuIKxZUMeta } from "/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexBOKtt9yhPtjzM00KkD2B__45eJkGGKcFmk41wVkM6_5_45YMeta || {},
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexElzlrUfl7Xe_45vz3SmScBZ1sWxcZI4vrTteIUPnIljrIMeta || {},
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indextAXpiDrfEEEtzGBCqDr8JpNF2YTayZxkK0e0vKhOT5wMeta || {},
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexs_451Ft4y0bb0rtX8idji3TovwKOKjShNipTzeQuIKxZUMeta || {},
    component: () => import("/codebuild/output/src1450835876/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]